import { render, staticRenderFns } from "./SearchBarScalesByWeight.vue?vue&type=template&id=473235a6&scoped=true"
import script from "./SearchBarScalesByWeight.vue?vue&type=script&lang=js"
export * from "./SearchBarScalesByWeight.vue?vue&type=script&lang=js"
import style0 from "./SearchBarScalesByWeight.vue?vue&type=style&index=0&id=473235a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473235a6",
  null
  
)

export default component.exports